import Vue from 'vue'
import Router from 'vue-router'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _fdea2a52 = () => interopDefault(import('../../../pages/old/App.vue' /* webpackChunkName: "" */))
const _67a72f65 = () => interopDefault(import('../../../pages/old/home/home.vue' /* webpackChunkName: "" */))
const _126ce1e5 = () => interopDefault(import('../../../pages/old/ajkRank/xiaoqu/communityHot.vue' /* webpackChunkName: "" */))
const _3a441286 = () => interopDefault(import('../../../pages/old/rank/borkerRank/borkerRank.vue' /* webpackChunkName: "" */))
const _07450e02 = () => interopDefault(import('../../../pages/old/rank/storeRank/storeRank.vue' /* webpackChunkName: "" */))
const _79d9e275 = () => interopDefault(import('../../../pages/old/ajkRank/qiangshou/index.vue' /* webpackChunkName: "" */))
const _65dd9a81 = () => interopDefault(import('../../../pages/old/wakeAPP/wakeAPP.vue' /* webpackChunkName: "" */))
const _9f656858 = () => interopDefault(import('~/layouts/non-available.vue' /* webpackChunkName: "" */))
const _7df77c8a = () => interopDefault(import('../../../pages/captcha-wangyi/index.vue' /* webpackChunkName: "" */))
const _7683ebc7 = () => interopDefault(import('../../../pages/captcha-geetest/index.vue' /* webpackChunkName: "" */))
const _202f4286 = () => interopDefault(import('../../../pages/trendency/index.vue' /* webpackChunkName: "" */))
const _240986f2 = () => interopDefault(import('../../../pages/old/ajkRank/synList/synList.vue' /* webpackChunkName: "" */))
const _7860ec1c = () => interopDefault(import('../../../pages/esf-package/index.vue' /* webpackChunkName: "" */))
const _7106c29d = () => interopDefault(import('../../../pages/map/index.vue' /* webpackChunkName: "" */))
const _ed465418 = () => interopDefault(import('../../../pages/agreement/carrier/index.vue' /* webpackChunkName: "" */))
const _0135f24b = () => interopDefault(import('../../../pages/weak/miniProgram/index.vue' /* webpackChunkName: "" */))
const _2d6e26ca = () => interopDefault(import('../../../pages/common-material/index.vue' /* webpackChunkName: "" */))
const _35ca62f0 = () => interopDefault(import('../../../pages/samsung-download/index.vue' /* webpackChunkName: "" */))
const _59f631eb = () => interopDefault(import('../../../pages/app/download/index.vue' /* webpackChunkName: "" */))
const _4dabaf02 = () => interopDefault(import('../../../pages/app/pano-report/index.vue' /* webpackChunkName: "" */))
const _ca4e2580 = () => interopDefault(import('../../../pages/app/result/index.vue' /* webpackChunkName: "" */))
const _6222cd93 = () => interopDefault(import('~/layouts/error.vue' /* webpackChunkName: "" */))

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: decodeURI('/'),
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/",
    component: _fdea2a52,
    alias: "/feapp",
    name: "App",
    children: [{
      path: ":city([a-z]+)/",
      component: _67a72f65,
      name: "mHome"
    }, {
      path: "ershou-autorank/xiaoqu",
      component: _126ce1e5,
      name: "communityHot"
    }, {
      path: "ershou-autorank/broker",
      component: _3a441286,
      name: "brokerRank"
    }, {
      path: "ershou-autorank/store",
      component: _07450e02,
      name: "storeRank"
    }, {
      path: "ershou-autorank/fangyuan/qiangshou/*",
      component: _79d9e275,
      name: "qiangshou"
    }, {
      path: "ershou-autorank/fangyuan/pinzhi/*",
      component: _79d9e275,
      name: "pinzhi"
    }, {
      path: "ershou-autorank/fangyuan/*",
      component: _79d9e275,
      name: "houseRank"
    }, {
      path: "/wake/app",
      component: _65dd9a81,
      name: "wakeApp"
    }]
  }, {
    path: "/non-available",
    component: _9f656858,
    name: "Non Available"
  }, {
    path: "/esfcommon-captcha-wy",
    component: _7df77c8a,
    name: "captcha"
  }, {
    path: "/esfcommon-captcha-geetest",
    component: _7683ebc7,
    name: "captcha"
  }, {
    path: "/pcesfcommon-captcha-wy",
    component: _7df77c8a,
    name: "captcha"
  }, {
    path: "/pcesfcommon-captcha-geetest",
    component: _7683ebc7,
    name: "captcha"
  }, {
    path: "/:city([a-z]+)/trendency/",
    component: _202f4286,
    name: "city-trendency"
  }, {
    path: "/:city([a-z]+)/trendency/:area_id(\\d+)_:block_id(\\d+)/",
    component: _202f4286,
    name: "block-trendency"
  }, {
    path: "/:city([a-z]+)/trendency/:area_id(\\d+)/",
    component: _202f4286,
    name: "area-trendency"
  }, {
    path: "/:city([a-z]+)/trendency/community/:comm_id",
    component: _202f4286,
    name: "community-trendency"
  }, {
    path: "/:city([a-z]+)/trendency/:area_id(\\d+)-q-:shangquan_id(\\d+)/",
    component: _202f4286,
    name: "shangquan-trendency"
  }, {
    path: "/:city([a-z]+)/trendency/:area_py(\\w+)/",
    component: _202f4286,
    name: "area-trendency"
  }, {
    path: "/:city([a-z]+)/trendency/:area_py(\\w+)-q-:shangquan_py(\\w+)/",
    component: _202f4286,
    name: "shangquan-trendency"
  }, {
    path: "/ershou-autorank/synList",
    component: _240986f2,
    name: "syn-rankList"
  }, {
    path: "/feapp/ershou-autorank/synList",
    component: _240986f2,
    name: "syn-rankList-wb"
  }, {
    path: "/ershou-autorank/common",
    component: _7860ec1c,
    name: "syn-com"
  }, {
    path: "/:city([a-z]+)/map/community",
    component: _7106c29d,
    name: "map"
  }, {
    path: "/xiaoqu/([a-zA-Z0-9]+)/map/community",
    component: _7106c29d,
    name: "mapwb"
  }, {
    path: "/agreement/carrier/:id",
    component: _ed465418,
    name: "agreement"
  }, {
    path: "/weak/miniProgram/esf",
    component: _0135f24b,
    name: "weakMiniProgramESF"
  }, {
    path: "/clbCfg/common/material",
    component: _2d6e26ca,
    name: "commonMaterial"
  }, {
    path: "/clb_cfg/menu/materialtemplate/materialtemplate",
    component: _2d6e26ca,
    name: "commonMaterialPath"
  }, {
    path: "/agreement/samsungDownload",
    component: _35ca62f0,
    name: "samsungDownload"
  }, {
    path: "/esfcommon/app/download",
    component: _59f631eb,
    name: "appDownload"
  }, {
    path: "/esfcommon/app/pano-report",
    component: _4dabaf02,
    name: "panoReport"
  }, {
    path: "/esfcommon/app/result",
    component: _ca4e2580,
    name: "panoReportResult"
  }, {
    path: "*",
    component: _6222cd93,
    name: "Not Found"
  }],

  fallback: false
}

export function createRouter () {
  return new Router(routerOptions)
}
